// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3Y4kA","checkboxCol":"Table_checkboxCol__wlXTL","emailCol":"Table_emailCol__39PD4","actionCol":"Table_actionCol__1Lzo_"};